import React, { useCallback, useMemo, useRef } from "react";
import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import "./index.css";
import Container from "../Container/Index";
import Swiperslider from "../Swiperslider/Index";
import ImageTag from "../ImageTag/Index";
import Title from "../Title/Index";

const Featureslider = ({ Data }) => {
  const lightGalleryInstance = useRef(null);
  const featureSlides = useMemo(() => Data?.featureData || [], [Data]);

  const lightGalleryItems = useMemo(
    () =>
      featureSlides.map((logo) => ({
        src: logo?.imagePath,
        thumb: logo?.imagePath,
        subHtml: `<p>${logo?.imageAlt || ""}</p>`,
      })),
    [featureSlides]
  );

  const handleLightGalleryInit = useCallback((detail) => {
    lightGalleryInstance.current = detail.instance;
  }, []);

  const openGalleryAt = useCallback((index) => {
    if (lightGalleryInstance.current) {
      lightGalleryInstance.current.openGallery(index);
    }
  }, []);

  return (
    <Container
      containerClass={"float-end p-0"}
      sectionID={'features'}
    >
      
        <div className="col-lg-6 col-sm-12 col-12 m-auto">
        <Title firstHeading={Data.heading} secondHeading={Data.title} />
        </div>
      <LightGallery
        onInit={handleLightGalleryInit}
        speed={500}
        plugins={[lgThumbnail, lgZoom]}
        dynamic
        dynamicEl={lightGalleryItems}
        elementClassNames="feature-lightgallery"
      />
      <div
        className="featureSlider bottomPosition"
        data-aos="fade-in"
        data-aos-offset="200"
        data-aos-duration="500"
        data-aos-once="true"
        data-aos-easing="ease-in-sine"
      >
        <Swiperslider slidesPerView={3.2}  spaceBetween={75} navigation={true} timeDelay={'600000'} tabspaceBetween={15}>
          {featureSlides.map((logo, index) => (
            <div
              className="col-12 position-relative featureSlide"
              key={index}
              onClick={() => openGalleryAt(index)}
            >
              <ImageTag ImagePath={logo.imagePath} ImageAlt={logo.imageAlt} />
              <span className="featureName text-uppercase text-center">{logo.imageAlt}</span>
              <div className="infoManufac flex-center">
              <div className="col-12 float-start d-flex flex-wrap gap-2">
              <span className="featureName text-uppercase fw-bold position-relative px-lg-4 px-3"><span className="greenBorder"></span>{logo.imageAlt}</span>
              <p className="m-0 px-lg-4 px-3">{logo.description}</p>
              </div>
              </div>
            </div>
          ))}
        </Swiperslider>
      </div>
    </Container>
  );
};

export default Featureslider;